import { render, staticRenderFns } from "./CreateProjectModalWizard.vue?vue&type=template&id=00c48732&scoped=true&"
import script from "./CreateProjectModalWizard.vue?vue&type=script&lang=js&"
export * from "./CreateProjectModalWizard.vue?vue&type=script&lang=js&"
import style0 from "./CreateProjectModalWizard.vue?vue&type=style&index=0&id=00c48732&prod&lang=less&scoped=true&"
import style1 from "./CreateProjectModalWizard.vue?vue&type=style&index=1&id=00c48732&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c48732",
  null
  
)

export default component.exports